// extracted by mini-css-extract-plugin
export default {"formItem":"Form__formItem___C6IKh","formLabel":"Form__formLabel___f39ZJ","nowrap":"Form__nowrap___hruLu","formContainer":"Form__formContainer___YeSVp"};